import { motion } from "framer-motion";

export default function SlideIn({ children }) {
  return <>{children}</>;
}
